import React from 'react';
import './TermsConditionsPage.css';

/**
 * TermsConditionsPage Component
 * 
 * This component renders the Terms & Conditions page for Ummeed ki Kiran Foundation.
 * It displays the organization's terms of use, donation policies, intellectual property rights,
 * website conduct guidelines, and legal information.
 * 
 * @returns {JSX.Element} The terms and conditions page component
 */
const TermsConditionsPage = () => {
    return (
        <div className="terms-conditions-page">
            <div className="terms-conditions-container">
                <div className="terms-conditions-content">
                    <header className="terms-conditions-header">
                        <h1>Terms & Conditions</h1>
                        <p className="effective-date">Effective Date: {new Date().toLocaleDateString()}</p>
                    </header>

                    <div className="terms-conditions-body">
                        <section className="policy-section">
                            <p>
                                Welcome to the official website of Ummeed ki Kiran Foundation ("we," "our," or "us"). By accessing or using our website, you agree to the following Terms & Conditions. Please read them carefully before using our site.
                            </p>
                        </section>

                        <section className="policy-section">
                            <h2>1. General Use</h2>
                            <p>
                                This website is owned and operated by Ummeed ki Kiran Foundation, a non-profit organization working towards supporting education, healthcare, and community development.
                            </p>
                            <p>
                                By using our website, you agree to comply with these Terms & Conditions, our Privacy Policy, and our Refund & Cancellation Policy.
                            </p>
                        </section>

                        <section className="policy-section">
                            <h2>2. Donations</h2>
                            <ul>
                                <li>All donations made to Ummeed ki Kiran Foundation are voluntary and non-refundable.</li>
                                <li>Donors are responsible for ensuring the accuracy of the information provided during the donation process.</li>
                                <li>We issue receipts for all donations as per applicable laws.</li>
                            </ul>
                        </section>

                        <section className="policy-section">
                            <h2>3. Content & Intellectual Property</h2>
                            <ul>
                                <li>All content on this website, including text, images, logos, graphics, and designs, is the property of Ummeed ki Kiran Foundation unless otherwise stated.</li>
                                <li>You may not copy, reproduce, distribute, or use our content without prior written permission.</li>
                                <li>Any unauthorized use of our content may result in legal action.</li>
                            </ul>
                        </section>

                        <section className="policy-section">
                            <h2>4. Website Use & Conduct</h2>
                            <ul>
                                <li>You agree not to use our website for any unlawful, harmful, or abusive purpose.</li>
                                <li>You must not attempt to hack, damage, or disrupt the functioning of our website.</li>
                                <li>We reserve the right to restrict or block access to anyone misusing our website.</li>
                            </ul>
                        </section>

                        <section className="policy-section">
                            <h2>5. Third-Party Links</h2>
                            <ul>
                                <li>Our website may contain links to third-party websites for informational purposes.</li>
                                <li>We are not responsible for the content, privacy practices, or activities of any third-party websites.</li>
                            </ul>
                        </section>

                        <section className="policy-section">
                            <h2>6. Limitation of Liability</h2>
                            <ul>
                                <li>Ummeed ki Kiran Foundation strives to ensure that information provided on our website is accurate and up-to-date. However, we do not guarantee completeness, reliability, or accuracy.</li>
                                <li>We are not liable for any loss, damage, or inconvenience caused by reliance on our website content.</li>
                            </ul>
                        </section>

                        <section className="policy-section">
                            <h2>7. Changes to Terms</h2>
                            <ul>
                                <li>We may update or modify these Terms & Conditions from time to time without prior notice.</li>
                                <li>Continued use of our website after changes are posted means you accept the updated terms.</li>
                            </ul>
                        </section>

                        <section className="policy-section">
                            <h2>8. Governing Law</h2>
                            <ul>
                                <li>These Terms & Conditions shall be governed by and interpreted in accordance with the laws of India.</li>
                                <li>Any disputes shall be subject to the jurisdiction of courts in Varanasi, Uttar Pradesh.</li>
                            </ul>
                        </section>

                        <section className="policy-section">
                            <h2>9. Contact Us</h2>
                            <p>If you have any questions about these Terms & Conditions, please contact us at:</p>
                            <div className="contact-info">
                                <p><strong>Ummeed ki Kiran Foundation</strong></p>
                                <p><strong>Email:</strong> <a href="mailto:support@ummeedkikiran.org">support@ummeedkikiran.org</a></p>
                                <p><strong>Phone:</strong> <a href="tel:+917985947303">+917985947303</a></p>
                                <p><strong>Address:</strong> S 17/314 D-15, Charan Nagar Colony Nadesar, Uttar Pradesh, India</p>
                            </div>
                        </section>
                    </div>

                    <div className="terms-conditions-footer">
                        <p>
                            By using our website and services, you acknowledge that you have read and understood these Terms & Conditions and agree to be bound by them.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsConditionsPage;